import React from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    Spinner,
} from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import useRetryRankingJob from '../../api/useRetryRankingJob';
import useAISearchProgress from '../../api/useAISearchProgress';

interface SearchFailedDialogProps {
    open: boolean;
    onClose: () => void;
}

const SearchFailedDialog = ({ open, onClose }: SearchFailedDialogProps) => {
    const { isMutating, trigger } = useRetryRankingJob();
    const { data } = useAISearchProgress();

    const onClick = async () => {
        const failedJobs = data?.rankingJobs?.filter((j) => j.status === 'Failed');
        const failedJobIds = failedJobs?.map((j) => j.jobId!);

        if (failedJobIds) {
            await trigger({ jobIds: failedJobIds });
        }
    };

    return (
        <Dialog
            open={open}
            onOpenChange={(isOpen) => {
                if (!isOpen) onClose();
            }}
        >
            <DialogContent className="max-w-2xl p-5" data-cy="SearchFailedDialog">
                <DialogHeader>
                    <DialogTitle>{UIStrings.UnexpectedErrorWhileIdentifyingCandidates}</DialogTitle>
                    <DialogDescription className="sr-only">{UIStrings.OopsError}</DialogDescription>
                </DialogHeader>
                <div className="flex flex-col gap-7">
                    <p className="text-sm">{UIStrings.UnexpectedErrorWhileIdentifyingCandidatesBody1}</p>
                    <p className="text-sm">{UIStrings.UnexpectedErrorWhileIdentifyingCandidatesBody2}</p>
                    <p className="text-sm">{UIStrings.UnexpectedErrorWhileIdentifyingCandidatesBody3}</p>
                </div>
                <div className="flex justify-end">
                    <Button
                        data-cy="ClientEditDialogSubmit"
                        variant="default"
                        size="lg"
                        onClick={onClick}
                        disabled={isMutating}
                    >
                        {isMutating && <Spinner className="mr-2 h-4 w-4" />}
                        {UIStrings.Retry}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default SearchFailedDialog;
